module.exports = __webpack_public_path__ + "Flag-52.e65b8f27c6a92b4bd87dbefeeaa58528.svg";